export const SET_STORIES_DATA = 'SET_STORIES_DATA';